import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";

type PropsDef = {
  isOpen: boolean;
  onClose: () => void;
};

export default function WaitlistConfirmationModal(props: PropsDef) {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();

  return (
    <ModalLayout isOpen={isOpen} classNames={`${styles.modal}`}>
      <div className={styles.confirmation_modal_content}>
        <div className={styles.title_and_content}>
          <div className={styles.title}>
            <i className={`ico ico-clock ${styles.info}`} />
            <h2>{t("You're on the waitlist.")}</h2>
          </div>
          <div className={styles.content}>
            {t("Sorry, all the available spots were booked. If a space become available you'll get a confirmation email")}
          </div>
          <div className={styles.button}>
            <button onClick={onClose} className={`${styles.confirm_button} btn btn-primary`}>
              {t("Ok")}
            </button>
          </div>
        </div>
      </div>
    </ModalLayout>
  );
}
